if (!customElements.get('sticky-add-to-cart')) {
  customElements.define(
    'sticky-add-to-cart',
    class StickyAddToCart extends HTMLElement {
      connectedCallback() {
        this.mainButton = document.getElementById(`ProductSubmitButton-${this.dataset.section}`);
        this.button = this.querySelector('.sticky-atc__button');
        if (!this.mainButton || !this.button) return;

        this.button.addEventListener('click', () => this.mainButton.click());

        // Mirror the main button so sold out / unavailable / loading states stay in sync.
        this.syncButton();
        this.buttonObserver = new MutationObserver(() => this.syncButton());
        this.buttonObserver.observe(this.mainButton, {
          attributes: true,
          attributeFilter: ['disabled', 'aria-disabled'],
          childList: true,
          subtree: true,
          characterData: true,
        });

        // Show the bar only once the main button has scrolled above the viewport.
        this.visibilityObserver = new IntersectionObserver(([entry]) => {
          this.toggle(!entry.isIntersecting && entry.boundingClientRect.top < 0);
        });
        this.visibilityObserver.observe(this.mainButton);
      }

      disconnectedCallback() {
        this.buttonObserver?.disconnect();
        this.visibilityObserver?.disconnect();
        document.body.classList.remove('sticky-atc-visible');
      }

      toggle(visible) {
        this.classList.toggle('is-visible', visible);
        this.inert = !visible;
        document.body.classList.toggle('sticky-atc-visible', visible);
      }

      syncButton() {
        const label = this.mainButton.querySelector('span')?.textContent.trim();
        if (label) this.button.querySelector('span').textContent = label;
        this.button.disabled = this.mainButton.disabled || this.mainButton.getAttribute('aria-disabled') === 'true';
      }
    }
  );
}
